export function hasToBeArray(any) {
  if (!any) {
    any = [];
  } else if (!Array.isArray(any)) {
    any = [any];
  }

  return any;
}
